import service from '@/api/intl';
import {loading, handleError} from '@/state/generators/helpers';

let pending = null;

export const state = {
    loading: false,
    item: {},
    service: service(),
    supportedLanguages: [],
    loadingSupportedLanguages: false,
    loadedSupportedLanguages: false,
    promiseSupportedLanguages: null,
}

export const getters = {
    loading: (state) => {
        return state.loading
    },
    item: (state) => (key) => {
        return JSON.parse(JSON.stringify(state.item[key] || state.supportedLanguages.reduce((acc,curr)=> (acc[curr]='',acc),{}) || {}));
    },
    supportedLanguages: (state) => {
        return JSON.parse(JSON.stringify(state.supportedLanguages));
    }
}

export const mutations = {
    'SET_LOADING': function (state, boolean = true) {
        state.loading = boolean;
    },

    'SET_LOADING_SUPPORTED_LANGUAGES': function (state, boolean = true) {
        state.loadingSupportedLanguages = boolean;
    },

    'SET_LOADED_SUPPORTED_LANGUAGES': function (state, boolean = true) {
        state.loadedSupportedLanguages = boolean;
    },

    'SET_ITEM': function (state, obj = {}) {
        state.item = Object.assign({}, state.item, obj);
    },

    'SET_SUPPORTED_LANGUAGES': function (state, list = []) {
        state.supportedLanguages = list;
    },

    'SET_PROMISE_SUPPORTED_LANGUAGES': function (state, promise) {
        state.promiseSupportedLanguages = promise;
    }
}

export const actions = {
    supportedLanguages: function ({commit, state, getters}) {
        loading(commit);

        if (state.supportedLanguages.length) {
            return getters.supportedLanguages;
        }

        if (pending) {
            return pending;
        }

        const request =  state.service.fetchSupportedLanguages().then(data => {
            commit('SET_SUPPORTED_LANGUAGES', data);
            loading(commit, false);
            return data;
        }).catch((e) => {
            handleError(e, commit);
        });

        pending = request;

        return request;
    },

    translationsOfKey: function ({commit, state}, key) {
        loading(commit);

        return state.service.fetchTranslationsOfKey({ translationKey: key }).then(data => {
            const item = {};
            item[key] = data;
            commit('SET_ITEM', item);
            loading(commit, false);
            return data;
        }).catch((e) => {
            handleError(e, commit);
        })
    },
}
